import ACTIONS from "../constants/actions";

const {
  GET_CHECK_TIME_REQUEST,
  GET_CHECK_TIME_REQUEST_SUCCESS,
  GET_CHECK_TIME_REQUEST_FAIL,
  GET_KEY_TO_CHECK_TIME_REQUEST_SUCCESS,
  GET_KEY_TO_CHECK_TIME_REQUEST,
  GET_KEY_TO_CHECK_TIME_REQUEST_FAIL,
  GET_CHECK_OUT,
  GET_CHECK_IN,
} = ACTIONS;

const initialState = {
  isLoadingCheckTime: false,
  isLoadingGetKeyToCheckTime: false,
  isCheckOut: false,
};

const checkTimePageReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHECK_TIME_REQUEST:
      return {
        ...state,
        isLoadingCheckTime: true,
      };
    case GET_CHECK_TIME_REQUEST_SUCCESS:
      return {
        ...state,
        isLoadingCheckTime: false,
        timeCheckData: action.payload,
      };
    case GET_CHECK_TIME_REQUEST_FAIL:
      return {
        ...state,
        isLoadingCheckTime: false,
      };
    case GET_KEY_TO_CHECK_TIME_REQUEST_SUCCESS:
      return {
        ...state,
        isLoadingGetKeyToCheckTime: false,
        keyToCheckTime: action.payload.code,
        expiredTime: action.payload.expiredTime,
      };
    case GET_KEY_TO_CHECK_TIME_REQUEST_FAIL:
      return {
        ...state,
        isLoadingGetKeyToCheckTime: false,
      };
    case GET_KEY_TO_CHECK_TIME_REQUEST:
      return {
        ...state,
        isLoadingGetKeyToCheckTime: true,
      };
    case GET_CHECK_OUT:
      return {
        isCheckOut: true,
      };
    case GET_CHECK_IN:
      return {
        isCheckOut: false,
      };
    default:
      return state;
  }
};
export default checkTimePageReducer;
